/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	creditTier: '',
	creditType: '',
	dealType: '',
	downPayment: 0,
	offerPrice: 0,
	term: 0,
	annualMiles: 0,
	tradeIn: null,
	icoTradeIn: {},
	penciling: {},
};

const paymentsInfoSlice = createSlice({
	name: 'paymentsInfo',
	initialState,
	reducers: {
		setPaymentsCalcPencilingDataUpdate(state, action) {
			const data = action.payload;
			const newDealType = data.dealType?.toLowerCase() || data.paymentLabel?.toLowerCase();
			if (newDealType) {
				state.dealType = newDealType;
			}
			state.downPayment = data.downPayment != null ? data.downPayment : state.downPayment;
			state.offerPrice = data.offerPrice != null ? data.offerPrice : state.offerPrice;
			state.term = data.term != null ? data.term : state.term;
			state.annualMiles = data.annualMiles != null ? data.annualMiles : state.annualMiles;
		},
		setPaymentsCalcResponse(state, action) {
			const data = action.payload;
			if (data.dealType) state.dealType = data.dealType;
			else if (data.paymentDefaultType) state.dealType = data.paymentDefaultType;
			if (data.loanTerm) state.loanTerm = data.loanTerm;
			if (data.leaseTerm) state.leaseTerm = data.leaseTerm;
			if (data.downPayment != null) state.downPayment = data.downPayment;
			state.tradeIn = data.tradeIn || state.tradeIn;
			state.icoTradeIn = data.icoTradeIn || state.icoTradeIn;
			state.penciling = data.penciling || state.penciling;
			if (data.creditType) {
				state.creditType = data.creditType;
			}
		},
	}
});

export const {
	setPaymentsCalcPencilingDataUpdate,
	setPaymentsCalcResponse,
} = paymentsInfoSlice.actions;

export default paymentsInfoSlice.reducer;
